import { NgModule, LOCALE_ID } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";

import { TranslatePipe } from "./pipes/translate.pipe";
import { StateService } from "./services/state.service";
import { TranslateWithValuePipe } from "./pipes/translateWithValue.pipe";

@NgModule({
  declarations: [
    TranslatePipe,
    TranslateWithValuePipe,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      deps: [StateService],
      useFactory: (StateService: { localeApp: string; }) => StateService.localeApp || "uk-UK",
    },
  ],
  exports: [
    TranslatePipe,
    TranslateWithValuePipe,
  ],
})
export class MedLocalizationModule {}
